module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#album",
      toString: function () {
        return this.url;
      }
    }